import Vue from 'vue'
import Vuex from 'vuex'

import createUser from './modules/user'
import createCart from './modules/cart'
import createFilters from './modules/filters'
import persistState from './plugins/persist-state'

Vue.use(Vuex)

export default (data) => {
  return new Vuex.Store({
    strict: true,
    state: {
      //
    },
    modules: {
      cart: createCart(data.cart || {}),
      user: createUser(data.user || null),
      filters: createFilters(data.filters || {})
    },
    plugins: [
      persistState
    ]
  })
}
